(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("jv8Pj", function(module, exports) {
const $e327c25e78eeff26$var$tables = document.querySelectorAll(".pd-variants-table");
const $e327c25e78eeff26$var$mainHeader = document.querySelector(".m-header");
$e327c25e78eeff26$var$tables.forEach((table)=>{
    const scroller = table.querySelector(".pd-variants-table__scroller");
    const header = table.querySelector(".pd-variants-table__header");
    const body = table.querySelector(".pd-variants-table__items");
    if (!scroller || !header || !body) return;
    const syncScroll = ()=>{
        scroller.scrollLeft = body?.scrollLeft ?? 0;
    };
    const handleOffset = ()=>{
        const height = $e327c25e78eeff26$var$mainHeader?.clientHeight ?? 0;
        if ($e327c25e78eeff26$var$mainHeader?.classList.contains("headroom--pinned")) header.style.setProperty("top", `${height}px`);
        else header.style.setProperty("top", "0px");
    };
    body.addEventListener("scroll", syncScroll);
    window.addEventListener("scroll", handleOffset);
});

});

})();
//# sourceMappingURL=variants-table.016484ec.js.map
